import { render } from "./RecaptchaNotice.vue?vue&type=template&id=47f0c28a&scoped=true"
const script = {}

import "./RecaptchaNotice.vue?vue&type=style&index=0&id=47f0c28a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f0c28a"]])

export default __exports__